import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";

export function ConflictWarning({ name, email, phone, excludeId }) {
  const [res, setRes] = useState(null);
  useEffect(() => {
    if ((name || "").trim().length < 3 && !email && (phone || "").replace(/\D/g, "").length < 6) { setRes(null); return; }
    const t = setTimeout(() => {
      api.get("/conflicts/check", { params: { name, email, phone, exclude_id: excludeId } }).then((r) => setRes(r.data)).catch(() => setRes(null));
    }, 450);
    return () => clearTimeout(t);
  }, [name, email, phone, excludeId]);

  if (!res || res.matches.length === 0) return null;
  const high = res.severity === "high";
  return (
    <div data-testid="conflict-warning" className={`rounded-md border p-4 text-sm ${high ? "bg-red-500/10 border-red-500/40" : "bg-amber-500/10 border-amber-500/40"}`}>
      <p className={`flex items-center gap-2 font-semibold ${high ? "text-red-200" : "text-amber-200"}`}>
        {high ? <ShieldAlert className="w-4 h-4" /> : <AlertTriangle className="w-4 h-4" />}
        {high ? "Potential conflict of interest" : "Possible duplicate record"} — {res.matches.length} match{res.matches.length > 1 ? "es" : ""}
      </p>
      <ul className="mt-2 space-y-1.5">
        {res.matches.slice(0, 5).map((m) => (
          <li key={`${m.type}-${m.id}`} className="flex items-start gap-2 text-xs text-slate-200" data-testid={`conflict-match-${m.type}`}>
            <span className={`mt-0.5 px-1.5 py-0.5 rounded text-[10px] uppercase tracking-wider font-semibold ${m.type === "other_party" ? "bg-red-500/20 text-red-200" : "bg-slate-500/30 text-slate-300"}`}>{m.type.replace("_", " ")}</span>
            <span><Link to={m.link} className="text-white hover:text-[var(--brand)] underline-offset-2 hover:underline" target="_blank" rel="noreferrer">{m.name}</Link> · {m.detail} <span className="text-slate-400">(matched on {m.reasons.join(", ")})</span></span>
          </li>))}
      </ul>
      <p className="text-[11px] text-slate-400 mt-2">Review before proceeding. You can still save this record.</p>
    </div>
  );
}
